import PropTypes from 'prop-types';
import React from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import EventBadgeList from './EventBadgeList';
import HotelBuildBid from './HotelBuildBid';

function compareGroupEvents(a, b) {
  if (a.group_name < b.group_name) {
    return -1;
  }
  if (a.group_name > b.group_name) {
    return 1;
  }
  // a must be equal to b
  return 0;
}

class GroupsHotelPicker extends React.Component {
  render() {
    if (!this.props.selectedEvent) {
      return (
        <div className="bid-panel-big">
          <h3>Select a city to get started.</h3>
        </div>
      );
    }
    const fetchingHotels = this.props.fetchingHotels;
    const groupEvents = this.props.selectedEvent.related_group_events;
    const groupHotelBids = groupEvents.sort(compareGroupEvents).map((event, i) => (
      <Tab key={event.id} eventKey={i} title={event.group_name}>
        <HotelBuildBid
          event={event}
          needFetch={event.id in fetchingHotels ? false : true}
          isFetching={event.id in fetchingHotels ? fetchingHotels[event.id] : false}
          hotels={event.id in this.props.hotels ? this.props.hotels[event.id] : []}
          selectHotel={this.props.selectHotel}
          favoriteHotel={this.props.favoriteHotel}
          searchHotels={this.props.searchHotels}
          editGroupEvent={this.props.editGroupEvent}
          showPrefs={this.props.showPrefs}
        />
      </Tab>
    ));
    return (
      <div className="bid-panel-big">
        <div className="bid-details">
          <Tabs defaultActiveKey={0}>{groupHotelBids}</Tabs>
        </div>
        <div className="bid-info">
          <EventBadgeList
            parentId={this.props.selectedEvent.id}
            events={this.props.selectedEvent.events}
          />
          <div>
            <hr />
            <p>
              <i style={{ color: 'green' }} className="fa fa-check-circle" />indicates hotel is
              verified on Catch
            </p>
          </div>
        </div>
      </div>
    );
  }
}

GroupsHotelPicker.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedEvent: PropTypes.object,
  fetchingHotels: PropTypes.object.isRequired,
  hotels: PropTypes.object.isRequired,
  selectHotel: PropTypes.func.isRequired,
  searchHotels: PropTypes.func.isRequired,
  favoriteHotel: PropTypes.func.isRequired,
  editGroupEvent: PropTypes.func.isRequired,
  showPrefs: PropTypes.func.isRequired,
};

GroupsHotelPicker.defaultProps = {
  groups: [],
  selectedEvent: null,
};

export default GroupsHotelPicker;



// WEBPACK FOOTER //
// src/routes/tours/components/GroupsHotelPicker.js